import { httpClientReactAdmin } from '../../lib'
import { DEFAULT_API_ADMIN, mapPath } from '../../constants'
import { getChainId } from '../../lib'

export default async (resourceName, params) => {
  // Mesmo mapeamento do DELETE unitário: recursos virtuais (money-products, boloes,
  // attendant-employees) não existem como rota no backend e viram 404 sem header CORS
  // — o browser reporta como erro de CORS.
  const path = mapPath[resourceName]

  const URL = `${DEFAULT_API_ADMIN}/${(path || resourceName || '').replace('chainId', getChainId())}`

  await Promise.all(params.ids.map(async id => await httpClientReactAdmin(`${URL}/${id}`, { method: 'DELETE' })))

  // Necessary workaround due to React Admin issue
  return { data: [] }
}
